import { useGetBranchListQuery } from "@me-team/host/main/branches/graphql/branches.hooks";

interface BranchesFilter {
    branchTypeId?: string;
    name?: string;
}

export const useBranches = (
    currentPage: number,
    itemsPerPage: number,
    filter: BranchesFilter,
    currentCompanyId: string,
    currentBranchEmployeeId: number | null | undefined,
    onlyActive: boolean = true,
    isDeleted?: boolean | null
) => {
    const { data, loading, error, refetch } = useGetBranchListQuery({
        skip: !currentCompanyId || !currentBranchEmployeeId,
        variables: {
            itemsPerPage,
            page: currentPage,
            branchTypeId: filter.branchTypeId ? Number(filter.branchTypeId) : null,
            name: filter.name ? filter.name : null,
            companyId: +currentCompanyId,
            employeeId: +currentBranchEmployeeId,
            onlyActive,
            isDeleted,
        },
        context: { errorType: "global" },
    });

    return { data, loading, error, refetch };
};
